import { render, staticRenderFns } from "./TableLogs.vue?vue&type=template&id=1153ef4a&"
import script from "./TableLogs.vue?vue&type=script&lang=js&"
export * from "./TableLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports